// extracted by mini-css-extract-plugin
module.exports = {"input":"input__2J5YR"};